import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FaceVeryHappySVG = function FaceVeryHappySVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16 2A14 14 0 112 16 14 14 0 0116 2zm6.08 15.43H9.81a1 1 0 00-.89 1c0 3.07 3.39 6.13 7.08 6.13s7.08-3.06 7.08-6.13a1 1 0 00-1-1zM12 11a2 2 0 102 2 2 2 0 00-2-2zm8 0a2 2 0 102 2 2 2 0 00-2-2z"
  }));
};
FaceVeryHappySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FaceVeryHappySVG);